import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-grow bg-gray-50 rounded-lg p-3 border border-gray-100" }
const _hoisted_2 = { class: "entity-details bg-white divide-y" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 p-2 capitalize text-left text-gray-400" }, "№", -1)
const _hoisted_5 = { class: "flex-1 p-2 text-left" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_8 = { class: "flex-1 p-2 text-left" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_11 = { class: "flex-1 p-2 text-left" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_14 = { class: "flex-1 p-2 text-left" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_17 = { class: "flex-1 p-2 text-left" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_20 = { class: "flex-1 p-2 text-left" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_23 = { class: "flex-1 p-2 text-left" }
const _hoisted_24 = {
  key: 0,
  class: "flex"
}
const _hoisted_25 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_26 = { class: "flex-1 p-2 text-left" }
const _hoisted_27 = {
  key: 1,
  class: "flex"
}
const _hoisted_28 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_29 = { class: "flex-1 p-2 text-left" }
const _hoisted_30 = {
  key: 2,
  class: "flex"
}
const _hoisted_31 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_32 = { class: "flex-1 p-2 text-left" }


import DocumentStatusLabel from "@/components/documents/DocumentStatusLabel.vue";
import { formatDateTime } from "@/utils/date";


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data.regNumber), 1)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("infoList.category")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.data.categoryName), 1)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("infoList.initiator")), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(__props.data.createdBy), 1)
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("infoList.theme")), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(__props.data.theme), 1)
      ]),
      _createElementVNode("li", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("infoList.index")), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(__props.data.index), 1)
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("infoList.createdAt")), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(formatDateTime)(__props.data.createdAt)), 1)
      ]),
      _createElementVNode("li", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("infoList.status")), 1),
        _createElementVNode("div", _hoisted_23, [
          (__props.data.status)
            ? (_openBlock(), _createBlock(DocumentStatusLabel, {
                key: 0,
                label: __props.data.status
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (__props.data.esedoDocumentType)
        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("esedo.documentType")), 1),
            _createElementVNode("div", _hoisted_26, _toDisplayString(__props.data.esedoDocumentType), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.esedoQuestionNature)
        ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("esedo.questionNature")), 1),
            _createElementVNode("div", _hoisted_29, _toDisplayString(__props.data.esedoQuestionNature), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.data.esedoPartners)
        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("esedo.partners")), 1),
            _createElementVNode("div", _hoisted_32, _toDisplayString(__props.data.esedoPartners), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})